import React from "react";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import './styles/OlvidoContrasenna.css'
import Swal from 'sweetalert2';

const contrasennaRegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/;

let baseUrl;
if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
else baseUrl='https://app-formacion.vercel.app';

const ReestablecerContrasenna = () => {
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [mensaje, setMensaje] = useState("");
  const [exito, setExito] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const emailParam = params.get("email") || "";
    setEmail(emailParam);
  }, [location.search]);

  const handleSubmit = async (e) => {
    e.preventDefault();
      setErrors({});
      setMensaje("");
      setExito(false);

    const errores = {};
    if (!contrasennaRegExp.test(password)) {
      errores.password = "Debe tener al menos 6 caracteres, mayúscula, minúscula y un número.";
    }

    if (password !== repeatPassword) {
      errores.repeatPassword = "Las contraseñas no coinciden.";
    }

    if (Object.keys(errores).length > 0) {
      setErrors(errores);
      return;
    }

    const res = await fetch(`${baseUrl}/api/users/reestablecerContrasenna`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, code, nuevaContrasenna: password })
    });

    const data = await res.json();
    setMensaje(data.message || data.error || "Error al cambiar la contraseña");
    setExito(res.ok);

    if (res.ok) {
      Swal.fire({
        icon: 'success',
        title: 'Contraseña cambiada',
        text: 'Serás redirigido al login.',
        confirmButtonText: 'Aceptar'
      }).then(() => {
        window.location.href = "/login"; 
      });
    }
  };
  

  return (
    <div className='olvidoContForm'>
      <div className='olvidoContWrapper'>
        <form onSubmit={handleSubmit}>
          <h2>Restablecer contraseña</h2>

          <input placeholder="Correo" value={email} className="input-boxOC" readOnly  />
          
          <input placeholder="Código" value={code} className="input-boxOC" onChange={e => setCode(e.target.value)} required />
          
          <input type="password" placeholder="Nueva contraseña" className="input-boxOC" value={password} onChange={e => setPassword(e.target.value)} required />
          {errors.password && <p style={{ color: "red" }}>{errors.password}</p>}
          
          <input type="password" placeholder="Repetir contraseña" className="input-boxOC" value={repeatPassword} onChange={e => setRepeatPassword(e.target.value)} required />
          {errors.repeatPassword && <p style={{ color: "red" }}>{errors.repeatPassword}</p>}
          
          <button type="submit">Cambiar contraseña</button>
          
          {mensaje && (
            <p style={{ color: exito ? "green" : "red", marginTop: "1rem" }}>{mensaje}</p>
          )}
        </form>
      </div>
    </div>
  );
};

export default ReestablecerContrasenna;